"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _constant = require("../constant");
var _utilities = _interopRequireDefault(require("../../utilities"));
var _Title = _interopRequireDefault(require("../Title"));
var _modal = _interopRequireDefault(require("./modal.proptypes"));
var _constant2 = require("./constant");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const containerStyleByViewPort = (val, theme, maxWidth) => {
  if (val === _constant.DEVICE_TYPE.DESKTOP) {
    return "\n        max-width: ".concat(maxWidth || '856px', ";\n    ");
  }
  if (val === _constant.DEVICE_TYPE.TABLET) {
    return "\n        margin: ".concat(theme.space.semiXXLarge, " ").concat(theme.space.XLarge, ";\n    ");
  }
  return "\n        width: auto;\n        margin: ".concat(theme.space.normal, "  ").concat(theme.space.XSmall, ";\n        max-height: calc(100% - (").concat(theme.space.normal, " * 2));\n    ");
};
const ModalWrapper = _styledComponents.default.div.withConfig({
  displayName: "Modal__ModalWrapper",
  componentId: "sc-130vjai-0"
})(_ref => {
  let {
    modalCenter,
    zIndex
  } = _ref;
  return "\n    ".concat(modalCenter ? "\n          position: fixed;\n          top: 0;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          z-index: ".concat(zIndex, ";\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        ") : '', "\n  ");
});
const ModalContainer = _styledComponents.default.div.withConfig({
  displayName: "Modal__ModalContainer",
  componentId: "sc-130vjai-1"
})(_ref2 => {
  let {
    theme,
    backgroundColor,
    viewPort,
    zIndex,
    width,
    fullScreen,
    height,
    modalCenter,
    modalRightAlign,
    maxWidth,
    minHeight
  } = _ref2;
  return "\n    position: fixed;\n    display: flex;\n    flex-direction: column;\n    top: 100%;\n    ".concat(!modalRightAlign ? "left : 0;" : '', "\n    right: 0;\n    width: ").concat(width || '100%', ";\n    z-index: ").concat(zIndex, ";\n    margin: ").concat(theme.space.semiXXLarge, " auto;\n    background-color: ").concat(theme.backgroundColor[backgroundColor], ";\n    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.16);\n    border-radius: ").concat(theme.borderRadius.normal, ";\n    min-height: ").concat(minHeight || '250px', ";\n    max-height: calc(100% - (").concat(theme.space.semiXXLarge, " * 2));\n    height: auto;\n    transition: ease-out 0.3s;\n\n    ").concat(containerStyleByViewPort(viewPort, theme, maxWidth), "\n\n    &.open {\n      top: 0;\n    }\n\n    ").concat(fullScreen ? "\n        margin: 0;\n        bottom: 0;\n        height: 100%;\n        max-height: 100%;\n        border-radius: 0;\n      " : '', "\n\n    ").concat(height ? "\n        height: ".concat(height, ";\n      ") : '', "\n\n    ").concat(modalCenter ? "\n          position: relative;\n          margin: 0;\n        " : '', "\n  ");
});
const ModalCloseBtnWrapper = _styledComponents.default.div.withConfig({
  displayName: "Modal__ModalCloseBtnWrapper",
  componentId: "sc-130vjai-2"
})(_ref3 => {
  let {
    isHeader,
    fixedCloseBtn,
    alignCloseBtn,
    theme
  } = _ref3;
  return "\n    ".concat((!isHeader || fixedCloseBtn) && "\n        position: absolute;\n        top: ".concat(theme.space.XSmall, ";\n        ").concat(alignCloseBtn, " : ").concat(theme.space.XSmall, ";\n        cursor: pointer;\n        height: auto;\n        z-index: 10;\n      "), "\n\n");
});
const ModalHeader = _styledComponents.default.div.withConfig({
  displayName: "Modal__ModalHeader",
  componentId: "sc-130vjai-3"
})(_ref4 => {
  let {
    theme,
    showHeaderBorder,
    headerPaddingBottom,
    isDropdown,
    customPadding,
    hasHeaderShadow,
    customHeaderProperties
  } = _ref4;
  return "\n    display: flex;\n    align-items: center;\n    padding: ".concat(customPadding ? "".concat(customPadding) : "".concat(theme.space.medium, " ").concat(theme.space.standard), ";\n    ").concat(headerPaddingBottom && !customPadding ? "padding-bottom: ".concat(theme.space[headerPaddingBottom], ";") : '', "\n    #modal-header-title {\n      flex: 1;\n      margin-left:").concat(isDropdown ? theme.space.small : '', " ;\n      font-size:").concat(isDropdown ? theme.fontSize.normal : '', " ;\n    }\n\n    ").concat(showHeaderBorder && "border-bottom: ".concat(hasHeaderShadow ? '0' : '1px', " solid ").concat(theme.colors.greyLight, ";"), "\n    box-shadow:").concat(hasHeaderShadow ? 'rgb(0 0 0 / 16%) 0px 1px 4px' : ' ', ";\n    ").concat(customHeaderProperties && customHeaderProperties.customBackgroundColor ? "background-color: ".concat(theme.backgroundColor[customHeaderProperties.customBackgroundColor], ";") : "", ";\n    z-index: 11;\n  ");
});
const ModalContentMarginPadding = (theme, withMargin, closeBtn, modalContentPaddingTop, viewPort, isStickyBtn) => {
  if (closeBtn) {
    return "\n      margin-top:  ".concat(theme.space.none, ";\n      padding: ").concat(viewPort === _constant.DEVICE_TYPE.MOBILE ? 0 : "".concat(theme.space[modalContentPaddingTop], " ").concat(theme.space.standard, " ").concat(isStickyBtn ? theme.space.none : theme.space.semi), ";\n    ");
  }
  return "";
};
const ModalContent = _styledComponents.default.div.withConfig({
  displayName: "Modal__ModalContent",
  componentId: "sc-130vjai-4"
})(_ref5 => {
  let {
    theme,
    withMargin,
    closeIcon,
    modalContentPaddingTop,
    modalContentOverflow,
    viewPort,
    customContentProperties,
    isStickyBtn
  } = _ref5;
  return "\n   flex: 1;\n   margin-top:  ".concat(theme.space.none, ";\n   padding: ").concat(theme.space.standard, " ").concat(theme.space.standard, " ").concat(theme.space.semi, "\n   };\n   ").concat(viewPort === _constant.DEVICE_TYPE.MOBILE ? "padding:0" : "", ";\n   overflow: ").concat(modalContentOverflow, ";\n  //  margin-right: ").concat(theme.space.tiny, ";\n\n   /* width */\n    ::-webkit-scrollbar {\n        width: 4px;\n    }\n\n    /* Track */\n    ::-webkit-scrollbar-track {\n        background: transparent;\n    }\n\n    /* Handle */\n    ::-webkit-scrollbar-thumb {\n        background: ").concat(theme.colors.greyMedium, ";\n        border-radius: ").concat(theme.borderRadius.normal, ";\n    }\n    ").concat(ModalContentMarginPadding(theme, withMargin, closeIcon, modalContentPaddingTop, viewPort, isStickyBtn), "\n    ").concat(customContentProperties && customContentProperties.contentPadding ? "padding: ".concat(customContentProperties.contentPadding, ";") : "", "\n    ").concat(customContentProperties && customContentProperties.contentMarginTop && !withMargin ? "margin-top: ".concat(customContentProperties.contentMarginTop, ";") : "", "\n    ").concat(customContentProperties && customContentProperties.backgroundColor ? "background-color: ".concat(theme.backgroundColor[customContentProperties.backgroundColor], ";") : "", "\n  ");
});
const ModalHeaderContent = _styledComponents.default.div.withConfig({
  displayName: "Modal__ModalHeaderContent",
  componentId: "sc-130vjai-5"
})(_ref6 => {
  let {
    fixedCloseBtn,
    alignCloseBtn
  } = _ref6;
  return "\n    align-items: center;\n    flex: 1;\n    z-index: 10;\n    ".concat(!fixedCloseBtn && "margin-".concat(alignCloseBtn, ": 16px;"), "\n  ");
});
const ModalOverlay = _styledComponents.default.div.withConfig({
  displayName: "Modal__ModalOverlay",
  componentId: "sc-130vjai-6"
})(_ref7 => {
  let {
    theme,
    backgroundColor,
    opacity,
    zIndex
  } = _ref7;
  return "\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: -1;\n    background-color: ".concat(theme.backgroundColor[backgroundColor], ";\n    opacity: 0;\n    transition: ease-out 0.2s;\n\n    &.open{\n      z-index: ").concat(zIndex, ";\n      opacity: ").concat(opacity, ";\n    }\n  ");
});
const ModalFooter = _styledComponents.default.div.withConfig({
  displayName: "Modal__ModalFooter",
  componentId: "sc-130vjai-7"
})(_ref8 => {
  let {
    fullScreen,
    theme
  } = _ref8;
  return "\n    display: flex;\n    align-items: center;\n    background-color: ".concat(theme.backgroundColor.default, ";\n    padding: 0 ").concat(theme.space.small, ";\n    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);\n    min-height: 80px;\n    height: auto;\n    z-index: 30;\n\n    ").concat(fullScreen && "\n        left: 0;\n        right: 0;\n        bottom: 0;\n      ", "\n\n    ");
});
const Modal = props => {
  const {
    children,
    backgroundColor,
    overlayBackgroundColor,
    overlayOpacity,
    onClose,
    openModal,
    viewPort,
    zIndex,
    width,
    title,
    fullScreen,
    accessible,
    customProperties,
    theme,
    headerContent,
    footerContent,
    alignCloseBtn,
    showCloseIcon,
    modalCenter,
    modalRightAlign,
    showHeaderBorder,
    headerTextColor,
    headerPaddingBottom,
    modalContentPaddingTop,
    modalContentOverflow,
    isDropdown,
    customHeaderPadding,
    isPreventClose,
    hasHeaderShadow,
    fixedCloseBtn,
    customContentProperties,
    customHeaderProperties,
    isStickyBtn
  } = props;
  const themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  const tabIndex = !accessible ? '-1' : '0';
  const [modalOpen, setModalOpen] = (0, _react.useState)(openModal);
  const overlayRef = (0, _react.useRef)(null);
  const modalRef = (0, _react.useRef)(null);
  const closeBtnRef = (0, _react.useRef)(null);
  const closeBtnAlignment = !alignCloseBtn ? 'right' : alignCloseBtn;
  (0, _react.useEffect)(() => {
    setModalOpen(openModal);
  }, [openModal]);
  (0, _react.useEffect)(() => {
    if (modalOpen) {
      overlayRef.current.classList.add('open');
      modalRef.current.classList.add('open');
      modalRef.current.focus();
    }
  }, [modalOpen]);
  const closeHandler = type => {
    if (onClose) {
      onClose(type);
    }
    if (showCloseIcon && !isPreventClose) {
      setModalOpen(false);
    }
  };
  (0, _react.useEffect)(() => {
    if (typeof document !== 'undefined') {
      const bodyElement = document.getElementsByTagName('body');
      if (bodyElement && !isDropdown) {
        if (modalOpen) {
          bodyElement[0].style.overflow = 'hidden';
        } else {
          bodyElement[0].style.removeProperty('overflow');
        }
      }
    }
  }, [isDropdown, modalOpen]);
  const headerContentWrapper = title ? /*#__PURE__*/_react.default.createElement(_Title.default, {
    type: "h3",
    theme: theme,
    customProperties: {
      id: 'modal-header-title',
      zIndex: 10
    },
    color: headerTextColor
  }, title) : /*#__PURE__*/_react.default.createElement(ModalHeaderContent, {
    alignCloseBtn: closeBtnAlignment,
    fixedCloseBtn: fixedCloseBtn
  }, headerContent);
  const forceFullScreen = viewPort === _constant.DEVICE_TYPE.MOBILE && headerContent;
  const getMain = () => {
    return modalOpen && /*#__PURE__*/_react.default.createElement(ModalWrapper, {
      modalCenter: modalCenter,
      zIndex: zIndex
    }, /*#__PURE__*/_react.default.createElement(ModalOverlay, {
      ref: overlayRef,
      onClick: () => closeHandler(_constant2.CANCEL),
      backgroundColor: overlayBackgroundColor,
      opacity: overlayOpacity,
      zIndex: zIndex,
      id: "airasia-phoenix-modal-overlay"
    }), /*#__PURE__*/_react.default.createElement(ModalContainer, (0, _extends2.default)({
      ref: modalRef,
      role: "dialog",
      "aria-modal": "true",
      tabIndex: tabIndex,
      open: modalOpen,
      backgroundColor: backgroundColor,
      viewPort: viewPort,
      zIndex: zIndex,
      width: width,
      fullScreen: fullScreen || forceFullScreen,
      customHeader: headerContent,
      id: "airasia-phoenix-modal-container",
      onKeyDown: e => _utilities.default.keyDownHandler(e, closeHandler, _constant.KEY_CODE.ESC),
      onBlur: e => _utilities.default.trapFocus(e, modalRef, closeBtnRef),
      modalCenter: modalCenter,
      modalRightAlign: modalRightAlign
    }, customProperties), title || headerContent ? /*#__PURE__*/_react.default.createElement(ModalHeader, {
      headerPaddingBottom: headerPaddingBottom,
      showHeaderBorder: showHeaderBorder,
      isDropdown: isDropdown,
      customPadding: customHeaderPadding,
      hasHeaderShadow: hasHeaderShadow,
      customHeaderProperties: customHeaderProperties
    }, closeBtnAlignment === 'right' ? headerContentWrapper : '', /*#__PURE__*/_react.default.createElement(ModalCloseBtnWrapper, {
      isHeader: title || headerContent,
      fixedCloseBtn: fixedCloseBtn,
      onClick: () => closeHandler(_constant2.CANCEL),
      id: "airasia-phoenix-modal-close-button",
      alignCloseBtn: closeBtnAlignment,
      onKeyDown: e => _utilities.default.keyDownHandler(e, closeHandler, _constant.KEY_CODE.ENTER),
      ref: closeBtnRef,
      tabIndex: "0",
      "aria-label": "Close modal button"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      fontsize: "titleNormal",
      icon: isDropdown ? 'ArrowBackIcon' : 'CloseIcon',
      color: "greyDark",
      accessible: false,
      theme: theme
    })), closeBtnAlignment === 'left' ? headerContentWrapper : '') : showCloseIcon && /*#__PURE__*/_react.default.createElement(ModalCloseBtnWrapper, {
      onClick: () => closeHandler(_constant2.CANCEL),
      id: "airasia-phoenix-modal-close-button",
      alignCloseBtn: closeBtnAlignment,
      onKeyDown: e => _utilities.default.keyDownHandler(e, closeHandler, _constant.KEY_CODE.ENTER),
      ref: closeBtnRef,
      tabIndex: "0",
      "aria-label": "Close modal button"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      fontsize: "titleNormal",
      icon: "CloseIcon",
      color: "greyDark",
      accessible: false,
      theme: theme
    })), /*#__PURE__*/_react.default.createElement(ModalContent, {
      withMargin: title || headerContent,
      viewPort: viewPort,
      closeIcon: showCloseIcon,
      id: "airasia-phoenix-modal-content",
      modalContentPaddingTop: modalContentPaddingTop,
      modalContentOverflow: modalContentOverflow,
      customContentProperties: customContentProperties,
      isStickyBtn: isStickyBtn
    }, children), footerContent && /*#__PURE__*/_react.default.createElement(ModalFooter, {
      id: "airasia-phoenix-modal-footer",
      fullScreen: fullScreen
    }, footerContent)));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
Modal.propTypes = _modal.default.PropTypes;
Modal.defaultProps = _modal.default.DefaultProps;
var _default = exports.default = Modal;